import { useState } from "react";

export default function Tabs({ tabs }) {
  const [active, setActive] = useState(tabs[0].id);

  const handleClick = (tab) => {
    setActive(tab.id);
    if (typeof tab.onClick === "function") {
      tab.onClick();
    }
  };

  const leftTabs = tabs.filter(t => t.align !== "right");
  const rightTabs = tabs.filter(t => t.align === "right");

  return (
    <div className="w-full">
      <div className="flex border-b border-gray-200">
        
        {/* Zakładki po lewej */}
        <div className="flex gap-1">
          {leftTabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => handleClick(tab)}
              className={`relative flex gap-2 px-4 py-2 text-xs font-medium transition
                ${active === tab.id ? "text-primary-700" : "text-gray-600 hover:text-black"}
              `}
            >
                {tab.icon && <span className="text-lg hidden sm:block">{tab.icon}</span>}

              {tab.label}
              {active === tab.id && (
                <span className="absolute bottom-0 left-0 right-0 h-[1px] bg-primary-600"></span>
              )}
            </button>
          ))}
        </div>

        {/* WYRZUCONE NA PRAWO */}
        <div className="flex ml-auto gap-1">
          {rightTabs.map(tab => (
          <button
  key={tab.id}
  onClick={() => handleClick(tab)}
  className={`relative flex items-center gap-2 px-4 py-2 text-xs font-medium transition
    ${active === tab.id ? "text-primary-700" : "text-gray-600 hover:text-black"}
  `}
>
  {/* IKONA */}
  {tab.icon && <span className="text-lg hidden sm:block ">{tab.icon}</span>}

  {/* TEKST */}
  {tab.label}

  {active === tab.id && (
    <span className="absolute bottom-0 left-0 right-0 h-[1px] bg-primary-600"></span>
  )}
</button>
          ))}
        </div>
      </div>

      {/* Zawartość zakładek */}
      <div className="mt-4">
        {tabs.map(tab =>
          active === tab.id ? <div key={tab.id}>{tab.content}</div> : null
        )}
      </div>
    </div>
  );
}
